
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Find the cart notification or drawer.
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            // Handle Shopify cart errors.
            if (response.status) {
              try {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors:
                    response.errors || response.description,
                  message: response.message,
                });
              } catch (error) {
                console.error(
                  'Cart error subscriber failed:',
                  error
                );
              }

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (soldOutMessage) {
                this.submitButton.setAttribute(
                  'aria-disabled',
                  true
                );

                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }

              this.error = true;
              return;
            }

            this.error = false;

            // If no notification component exists,
            // send the customer to the cart page.
            if (!this.cart) {
              window.location.href = routes.cart_url;
              return;
            }

            // Notify other theme components of cart updates.
            // Subscriber errors should not prevent the
            // confirmation from opening.
            let startMarker = null;

            try {
              if (typeof CartPerformance !== 'undefined') {
                startMarker =
                  CartPerformance.createStartingMarker(
                    'add:wait-for-subscribers'
                  );
              }

              Promise.resolve(
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                })
              )
                .then(() => {
                  if (
                    startMarker &&
                    typeof CartPerformance !== 'undefined'
                  ) {
                    CartPerformance.measureFromMarker(
                      'add:wait-for-subscribers',
                      startMarker
                    );
                  }
                })
                .catch((error) => {
                  console.error(
                    'Cart update subscriber error:',
                    error
                  );
                });

            } catch (error) {
              console.error(
                'Cart update subscriber error:',
                error
              );
            }

            // Render the cart notification.
            const renderCartNotification = () => {
              try {
                if (
                  typeof CartPerformance !== 'undefined'
                ) {
                  CartPerformance.measure(
                    'add:paint-updated-sections',
                    () => {
                      this.cart.renderContents(response);
                    }
                  );
                } else {
                  this.cart.renderContents(response);
                }
              } catch (error) {
                console.error(
                  'Cart notification rendering error:',
                  error
                );

                // Fallback: allow customers to access
                // their updated cart even if rendering fails.
                this.handleErrorMessage(
                  'Item added to cart. Please view your cart to continue.'
                );

                const existingLink =
                  this.querySelector('.vzx-cart-fallback-link');

                if (!existingLink) {
                  const link = document.createElement('a');

                  link.href = routes.cart_url;
                  link.textContent = 'View Cart & Continue';
                  link.className = 'vzx-cart-fallback-link';

                  link.style.display = 'block';
                  link.style.marginTop = '12px';
                  link.style.textDecoration = 'underline';

                  this.appendChild(link);
                }
              }
            };

            // Support Shopify quick-add modals.
            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(renderCartNotification, 0);
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              renderCartNotification();
            }
          })
          .catch((error) => {
            console.error(
              'Add to cart request failed:',
              error
            );

            this.handleErrorMessage(
              'Unable to update your cart. Please try again.'
            );
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            if (spinner) {
              spinner.classList.add('hidden');
            }

            if (typeof CartPerformance !== 'undefined') {
              CartPerformance.measureFromEvent(
                'add:user-action',
                evt
              );
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
